import { GET_ALL_HIDDEN_PROPERTIES } from "./types";
import axios from "axios";
import { toast } from "react-toastify";

const PROXY = process.env.REACT_APP_URL + "api/";

export const getAllHiddenProperties = (page, limit) => async (dispatch) => {
  const res = await axios.get(`${PROXY}hidden?page=${page}&limit=${limit}`);
  dispatch({
    type: GET_ALL_HIDDEN_PROPERTIES,
    payload: res?.data?.result,
  });
};

export const unHideProperties = (id) => async (dispatch) => {
  const res = await axios.delete(`${PROXY}hidden/${id}`);
  //toast.success(res.data.message);
  return res;
};
